import { useTranslation } from 'react-i18next';

import ReviewCard from '~/components/review/ReviewCard';
import EmblaSlider from '~/components/Slider/EmblaSlider';
import { Review } from '~/types/Review';

const GOOGLE_REVIEWS_URL =
  'https://www.google.com/search?sca_esv=5999353cb99206ac&hl=cs-CZ&biw=1920&bih=911&sxsrf=APpeQnvMcCaFTIaQSy_JYV5uPspQb10t9g:1784536928078&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_0V1KbZ4orj4jPcds8imc5r6saiIWKu-vtgxhW6pi9BSCCnuOjSwmrhIGsfFfy9s8A91d4Zb0RlMzoVlZr8oBwOqL-4YgrVlsbxPktA7SKVANo3htizWCHdDmXXR0h1i9Ea25rhnfT2_Yk_ADZwq77Ldh9Ms&q=Anders%26Kafka+-+N%C3%A1vrhy+a+realizace+saun+na+m%C3%ADru+Recenze&sa=X&ved=2ahUKEwis3b6N7uCVAxVc9LsIHSj0NjUQ0bkNegQIKxAI';

const GoogleLogo = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M60.0028 32.6219C60.0028 30.3197 59.8121 28.6397 59.3996 26.8975H32.5742V37.2884H48.3201C48.0028 39.8708 46.2885 43.7597 42.4789 46.3728L42.4255 46.7207L50.9072 53.16L51.4948 53.2175C56.8915 48.333 60.0028 41.1463 60.0028 32.6219Z"
      fill="#4285F4"
    />
    <path
      d="M32.5726 60C40.2868 60 46.7628 57.511 51.4931 53.2177L42.4773 46.3731C40.0646 48.022 36.8265 49.1731 32.5726 49.1731C25.0171 49.1731 18.6045 44.2887 16.3186 37.5376L15.9835 37.5655L7.16416 44.2544L7.04883 44.5686C11.7472 53.7153 21.398 60 32.5726 60Z"
      fill="#34A853"
    />
    <path
      d="M16.3203 37.5377C15.7171 35.7955 15.368 33.9287 15.368 31.9999C15.368 30.0709 15.7171 28.2043 16.2885 26.4621L16.2725 26.0911L7.34264 19.2947L7.05047 19.4309C5.11405 23.2265 4.00293 27.4888 4.00293 31.9999C4.00293 36.511 5.11405 40.7731 7.05047 44.5687L16.3203 37.5377Z"
      fill="#FBBC05"
    />
    <path
      d="M32.5728 14.8266C37.9378 14.8266 41.5567 17.0977 43.6203 18.9956L51.6838 11.28C46.7316 6.7689 40.2869 4 32.5728 4C21.398 4 11.7472 10.2844 7.04883 19.431L16.2869 26.4622C18.6046 19.7111 25.0172 14.8266 32.5728 14.8266Z"
      fill="#EB4335"
    />
  </svg>
);

interface Props {
  reviews: Review[];
}

const ReviewsBlock = ({ reviews }: Props) => {
  const { t } = useTranslation();

  if (reviews.length === 0) return null;

  return (
    <div className="reviews">
      <div className="reviews-header">
        <div className="reviews-header__subtitle-row">
          <p className="reviews-header__subtitle">{t('components.reviews_block.subtitle')}</p>
          <a
            className="reviews-header__google-link"
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('components.reviews_block.google_reviews_aria')}
          >
            <GoogleLogo />
          </a>
        </div>
        <h3 className="reviews-header__title">{t('components.reviews_block.title')}</h3>
      </div>
      <EmblaSlider slideClass="reviews__slide" className="embla--branded">
        {reviews.map((item, index) => (
          <ReviewCard {...item} key={index} />
        ))}
      </EmblaSlider>
    </div>
  );
};

export default ReviewsBlock;
